export default () => ({
  data: {
    token: null,
    expires: null,
  },
  user: {},
})
